import { useState, useEffect, useRef } from "react";

import styles from "../dash_styles/modifylanding.module.css";
import getImgUrl from '../../helper/getImgUrl';

import { CiTrash } from "react-icons/ci";
import { MdClose } from "react-icons/md";

import api from '../../api/axios';

const ModifyLanding = () => {
    const [pageData, setPageData] = useState({});
    const [feedbackData, setFeedbackData] = useState([]);
    const [isFeedOpen, setIsFeedOpen] = useState(false);

    const [formData, setFormData] = useState({
        intro: '',
        maintitle: '',
        mainphoto: null,
    });

    const [feedbackForm, setFeedbackForm] = useState({
        review: '',
        review_author: '',
        roles: ''
    });

    const mainPhoto = useRef();

    const fetchLandingData = async () => {
        try {
            const res = await api.get('/landingdata');
            setPageData(res.data)
        } catch (error) {
            console.error('Error fetching landing page data', error);
        }
    };

    const fetchFeedbackData = async () => {
        try {
            const res = await api.get('/feedback');
            setFeedbackData(res.data);
        } catch (error) {
            console.error('Error fetching feedback data');
        }
    };

    useEffect(() => {
        fetchLandingData();
        fetchFeedbackData();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleFeedbackInput = (e) => {
        const { name, value } = e.target;
        setFeedbackForm((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: files[0]
        }));
    };

    const handleCancelFeedForm = () => {
        setFeedbackForm({
            review: '',
            review_author: '',
            roles: ''
        })
        setIsFeedOpen(false);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const submitData = new FormData();
            Object.entries(formData).forEach(([key, value]) => {
                if (value) submitData.append(key, value);
            });

            await api.put(
                '/landingdata/edit',
                submitData,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            
            await fetchLandingData();
            setFormData({
                intro: '',
                maintitle: '',
                mainphoto: null,
            });
            mainPhoto.current.value = '';
        } catch(error) {
            console.error('Error updating landing page data:', error);
            alert('Error updating landing page data');
        }
    };

    const handleFeedbackSubmit = async (e) => {
        e.preventDefault();
        try {
            await api.post('/feedback/new', feedbackForm);
            setFeedbackForm({
                review: '',
                review_author: '',
                roles: ''
            });
            setIsFeedOpen(false);
            await fetchFeedbackData();
        } catch (error) {
            console.error('Error adding feedback', error);
            alert('Error adding feedback');
        }
    };

    const handleDeleteFeedback = async (feedId) => {
        if (!window.confirm('Are you sure you want to delete this feedback?')) return;

        try {
            await api.delete(`/feedback/delete/${feedId}`)
            await fetchFeedbackData();
        } catch (error) {
            console.error('Error deleting feedback', error)
            alert('Error deleting feedback');
        }
    };

    return (
        <div className={styles.main_body}>
            <div className={styles.pageEdit}>
                <div className={styles.mainTableContainer}>
                    <div className={styles.labelContainer}>
                        <div className={styles.label}>
                            <p>Landing page management</p>
                        </div>
                        <div className={styles.filterOrder}>
                            
                        </div>
                    </div>
                    <div className={styles.outerTable}>
                        <form onSubmit={handleSubmit}>
                            <table>
                                <thead>
                                    <tr>
                                        <th className={styles.col1}>content location</th>
                                        <th className={styles.col2}>content type</th>
                                        <th className={styles.col3}>content</th>
                                        <th className={styles.col4}>input</th>
                                        <th className={styles.col5}>action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Main title</td>
                                        <td>Text</td>
                                        <td>{pageData?.maintitle}</td>
                                        <td>
                                            <input
                                                type='text'
                                                name='maintitle'
                                                placeholder="Enter new title"
                                                value={formData.maintitle}
                                                onChange={handleInputChange}
                                            />
                                        </td>
                                        <td><button type='submit'>Apply change</button></td>
                                    </tr>
                                    <tr>
                                        <td>Intro</td>
                                        <td>Text</td>
                                        <td>{pageData?.intro}</td>
                                        <td>
                                            <textarea
                                                name='intro'
                                                onChange={handleInputChange}
                                                className={styles.tableArea}
                                                value={formData.intro}
                                                placeholder="Enter new intro"
                                            ></textarea>
                                        </td>
                                        <td><button type='submit'>Apply change</button></td>
                                    </tr>
                                    <tr>
                                        <td>Landing photo</td>
                                        <td>Picture</td>
                                        <td><img src={getImgUrl(pageData?.mainphoto)} alt=''/></td>
                                        <td>
                                            <input
                                                type='file'
                                                name='mainphoto'
                                                onChange={handleFileChange}
                                                ref={mainPhoto}
                                            />
                                        </td>
                                        <td><button type='submit'>Apply change</button></td>
                                    </tr>
                                </tbody>
                            </table>
                        </form>
                    </div>
                </div>
            </div>
            <div className={styles.feedback}>
                <div className={styles.mainTableContainer}>
                    <div className={styles.labelContainer}>
                        <div className={styles.label}>
                            <p>Feedback management</p>
                        </div>
                        <div className={styles.filterOrder}>
                            <button onClick={() => setIsFeedOpen(prev => !prev)}>Add feedback</button>
                        </div>
                    </div>
                    <div className={styles.outerTable}>
                        <form onSubmit={handleSubmit}>
                            <table>
                                <thead>
                                    <tr>
                                        <th className={styles.col1}>author</th>
                                        <th className={styles.col2}>Role</th>
                                        <th className={styles.col3}>content</th>
                                        <th className={styles.col5}>action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(feedbackData) && feedbackData.map(feed => (
                                        <tr key={feed.id}>
                                            <td><p>{feed.review_author}</p></td>
                                            <td><p>{feed.roles}</p></td>
                                            <td><p>{feed.review}</p></td>
                                            <td><CiTrash className={styles.deleteIcon} onClick={() =>handleDeleteFeedback(feed.id)}/></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </form>
                    </div>
                </div>
            </div>
            {isFeedOpen && (
                <div className={styles.addWrapper}>
                    <div className={styles.addFeedback}>
                        <div className={styles.topAdd}>
                            <h3>Add feedback</h3>
                            <MdClose className={styles.closeIcon} onClick={handleCancelFeedForm}/>
                        </div>
                        <div className={styles.middleAdd}>
                            <form id="feedForm" onSubmit={handleFeedbackSubmit}>
                                <div className={styles.inputBox}>
                                    <p>Author</p>
                                    <input
                                        type="text"
                                        name="review_author"
                                        placeholder="Feedback author"
                                        value={feedbackForm.review_author}
                                        onChange={handleFeedbackInput}
                                    />
                                </div>
                                <div className={styles.inputBox}>
                                    <p>Role</p>
                                    <input
                                        name="roles"
                                        type="text"
                                        placeholder="Role"
                                        value={feedbackForm.roles}
                                        onChange={handleFeedbackInput}
                                        maxLength={50}
                                    />
                                </div>
                                <div className={styles.inputBoxArea}>
                                    <p>Feedback/review</p>
                                    <textarea 
                                        name="review"
                                        placeholder="Feedback/review"
                                        value={feedbackForm.review}
                                        onChange={handleFeedbackInput}
                                        maxLength={370}
                                        className={styles.textareaAdd}
                                    ></textarea>
                                </div>
                            </form>
                        </div>
                        <div className={styles.bottomAdd}>
                            <button onClick={handleCancelFeedForm}>Cancel</button>
                            <button type="submit" form="feedForm" className={styles.save}>Save</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ModifyLanding